<template>
  <div>
    <div
      style="width: 1300px; margin: 0 auto"
      id="v-content"
      :style="{ minHeight: Height + 'px' }"
    >
      <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888">
        <p class="mt-2 mb-0">
          <span
            class="p-1 ml-2"
            style="
              text-shadow: #000 1px 0 0;
              background-color: #3190e8;
              color: #fff;
              box-shadow: 6px 4px 9px #888888;
              font-family: Helvetica Neue, Tahoma, Arial;
              border-radius: 3px;
            "
          >
            入库凭证
          </span>
          <span
            class="float-right span_close mr-1"
            style="
              display: block;
              width: 20px;
              line-height: 20px;
              text-align: center;
              font-size: 25px;
            "
            @click="$router.go(-1)"
          >
            &times;
          </span>
        </p>
        <p class="mb-0 mt-2" style="font-weight: 600; color: red">
          (单击表头显示列表信息)
        </p>

        <div class="row ml-2 mt-2 mb-2">
          <div class="col-lg-6">
            <div class="row">
              <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-6">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">
                        供应商名称:
                      </div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.supplierNum"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">药品名称:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.drugNameOrCode"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="row ml-lg-2">
              <button
                class="btn-primary font_btn ml-lg-2 button_zi"
                @click="getSupplierOrder()"
              >
                查询
              </button>
            </div>
          </div>
        </div>
        <div v-if="showPage">
          <table class="table table-striped table-hover sett">
            <thead>
              <tr style="white-space: nowrap" @click="changeWidth($event)">
                <th class="autocut">订单号</th>
                <th class="autocut">供应商</th>
                <th class="autocut">数量</th>
                <th class="autocut">进价</th>
                <th class="autocut">批量价</th>
                <th class="autocut">创建时间</th>
                <th class="autocut">品种编号</th>
                <th class="autocut">品名</th>
                <th class="autocut">产地</th>
                <th class="autocut">包装</th>
                <th class="autocut">剂型或类型</th>
                <th class="autocut">单位</th>
                <th class="autocut">批准文号</th>
                <th class="autocut">状态</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in tableList"
                :key="index"
                style="white-space: nowrap"
              >
                <td class="text-center sett-td">{{ item.num }}</td>
                <td class="text-center sett-td">{{ item.supplierName }}</td>
                <td class="text-center sett-td">{{ item.counts }}</td>
                <td class="text-center sett-td">{{ item.purchPrice }}</td>
                <td class="text-center sett-td">{{ item.wholePrice }}</td>
                <td class="text-center sett-td">{{ item.createDate | utc }}</td>
                <td class="text-center sett-td">{{ item.drugNum }}</td>
                <td class="text-center sett-td">{{ item.drugName }}</td>
                <td class="text-center sett-td">{{ item.factroy }}</td>
                <td class="text-center sett-td">{{ item.pack }}</td>
                <td class="text-center sett-td">{{ item.drugType }}</td>
                <td class="text-center sett-td">{{ item.drugUnit }}</td>
                <td class="text-center sett-td">{{ item.approvalNum }}</td>
                <td class="text-center sett-td">{{ item.states }}</td>
              </tr>
            </tbody>
          </table>
          <!-- <div>
                                                        <v-pagination :total="total" :current-page='current' @pagechange="pagechange"></v-pagination>
                                             </div>
                                          -->
          <p class="text-center">
            <img
              src="../../static/images/tuding.png"
              style="width: 1.5rem; height: 1.5rem"
              alt=""
            />
          </p>
        </div>

        <div v-else>
          <img
            src="../../static/images/wushuju.jpg"
            style="width: 300px; height: 300px; display: block; margin: 0 auto"
            alt=""
          />
        </div>
      </div>
    </div>
    <div>
      <transition name="fade">
        <loading v-if="isLoading"></loading>
      </transition>
    </div>
  </div>
</template>
<script>
import vPagination from "../components/Pagination.vue";
import date from "../components/Date.vue";
import date3 from "../components/Date3.vue";
import Loading from "../components/Loading.vue";
export default {
  data() {
    return {
      Height: 0,
      showChuang: false,
      showPage: true,
      searchForm: {
        supplierNum: "",
        drugNameOrCode: "",
        searchKey1: "",
        searchKey2: "",
        searchKey3: "",
        DateMoreThan: "",
        DateLessThan: "",
        DateLessThan1: "",
        DateMoreThan1: "",
        DateLessThan_getOrder: "",
      }, //搜索内容

      searchData: [], //搜索返回的清单
      tableList: [],
      Record: "", //总记录数
      Pcount: "", //总页数
      PageNo: 1, //当前页码

      total: 1, // 记录总条数
      display: 20, // 每页显示条数
      current: 1, // 当前的页数

      isLoading: false,
      supplierList: [],
      drugList: [],

      showChaxun: false,
      showImage: false,
    };
  },
  components: {
    vPagination,
    date,
    Loading,
    date3,
  },
  filters: {
    formatUTC: function (utc_datetime) {
      let time = utc_datetime.replace(/T/gi, "  ").substring(0, 10);
      let cuttime1 = new Date(time).getTime();
      let cuttime2 = new Date().getTime() + 24 * 60 * 60 * 1000;
      if (cuttime1 < cuttime2) {
        return "批准文号已过期";
      }
    },
    utc: function (utc_datetime) {
      return utc_datetime.replace(/T/gi, "  ").substring(0, 20);
    },
    changeDate(date) {
      let change_date =
        date.slice(0, 4) + "-" + date.slice(4, 6) + "-" + date.slice(6, 9);
      return change_date + " 00:00:00";
    },
    changeDate1(date) {
      let time_change =
        date.slice(0, 4) + "-" + date.slice(4, 6) + "-" + date.slice(6, 9);
      let year = new Date(
        new Date(time_change).getTime() - 24 * 60 * 60 * 1000
      ).getFullYear();

      let month =
        new Date(
          new Date(time_change).getTime() - 24 * 60 * 60 * 1000
        ).getMonth() + 1;

      let time_date = new Date(
        new Date(time_change).getTime() - 24 * 60 * 60 * 1000
      ).getDate();

      let time;
      if (month < 10) {
        if (time_date < 10)
          time = year + "-" + "0" + month + "-" + "0" + time_date;
        else {
          time = year + "-" + "0" + month + "-" + time_date;
        }
      } else {
        if (time_date < 10) {
          time = year + "-" + month + "-" + "0" + time_date;
        } else {
          time = year + "-" + month + "-" + time_date;
        }
      }

      let change_date = time;
      return change_date + " 23:59:59";
    },
  },
  methods: {
    searchEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getSupplierOrder();
      }
    },

    changeDate1: function (date) {
      this.searchForm.DateLessThan = date.replace(/\-/g, "");
      this.searchForm.DateLessThan1 = date;
    },
    changeDate2: function (date) {
      let year = new Date(
        new Date(date).getTime() + 24 * 60 * 60 * 1000
      ).getFullYear();

      let month =
        new Date(new Date(date).getTime() + 24 * 60 * 60 * 1000).getMonth() + 1;

      let time_date = new Date(
        new Date(date).getTime() + 24 * 60 * 60 * 1000
      ).getDate();

      let time;
      if (month < 10) {
        if (time_date < 10) time = "" + year + "0" + month + "0" + time_date;
        else {
          time = "" + year + "0" + month + time_date;
        }
      } else {
        if (time_date < 10) {
          time = "" + year + month + "0" + time_date;
        } else {
          time = "" + year + month + time_date;
        }
      }

      this.searchForm.DateMoreThan = time;

      this.searchForm.DateMoreThan1 = date;
    },
    changeWidth: function (e) {
      if (e.target.className.indexOf("add_autocut") > -1) {
        $(e.target).removeClass("add_autocut");
      } else {
        $(e.target).addClass("add_autocut");
      }
    },

    getDay(day) {
      var today = new Date();
      var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码
      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      return tYear + "-" + tMonth + "-" + tDate;
    },
    doHandleMonth(month) {
      var m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      return m;
    },
    getDay1(day) {
      //  console.log(day)
      var today = new Date();
      var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码
      // 　                console.log(today)
      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      // console.log(tYear +""+ tMonth +""+ tDate)
      return tYear + "" + tMonth + "" + tDate;
    },
    doHandleMonth(month) {
      var m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      return m;
    },
    getSupplierOrder: async function (PageIndex) {
      const that = this;
      let threeMonth = that.getDay(-3 * 30);

      let threeMonthTime = new Date(threeMonth).getTime();

      let today = that.getDay(0);
      let todayTime = new Date(today).getTime();

      let select = that.searchForm.DateLessThan1;

      let select1 = that.searchForm.DateMoreThan1;
      let seTime = new Date(select).getTime();

      let seTime2 = new Date(select1).getTime();

      let ces = that.searchForm.DateLessThan;
      let a = ces.slice(0, 4) + "-" + ces.slice(4, 6) + "-" + ces.slice(6, 9);
      // console.log(a)
      let ces1 = that.searchForm.DateMoreThan;
      let b =
        ces1.slice(0, 4) + "-" + ces1.slice(4, 6) + "-" + ces1.slice(6, 9);
      // console.log(b)
      let cesTime = new Date(a).getTime();
      // console.log(cesTime)
      let cesTime2 = new Date(b).getTime();
      // console.log(cesTime2)
      if (cesTime >= cesTime2) {
        alert("开始日期要小于结束日期");
      } else {
        if (
          threeMonthTime <= seTime &&
          seTime <= todayTime &&
          threeMonthTime <= seTime2 &&
          seTime2 <= todayTime
        ) {
          this.isLoading = true;

          if (!PageIndex) {
            PageIndex = 1;
          }
          that.PageNo = PageIndex || that.PageNo;
          const { data: res } = await this.$http.post("Dls/getFun", {
            action: "ClerkdrQueryOrderInStore",
            obj: JSON.stringify({
              PageIndex,
              supplierNameOrCode: that.searchForm.supplierNum,
              drugNameOrCode: that.searchForm.drugNameOrCode,
            }),
          });

          console.log(res);
          if (res.isok) {
            const obj = res.data;
            that.tableList = obj.rows;

            if (that.tableList.length > 0) {
              that.showPage = true;
            } else {
              that.showPage = false;
            }
            that.Pcount = obj.pcount;
            that.Record = obj.record;
            that.total = obj.record;
            that.isLoading = false;
          }
        } else {
          alert("请选择三个月以内的时间进行查询,查询日期不大于当天");
        }
      }
    },

    pagechange: function (currentPage) {
      this.getSupplierOrder(currentPage);
    },
  },
  mounted() {},
  mounted() {
    this.Height = document.documentElement.clientHeight - 100;
    window.onresize = () => {
      this.Height = document.documentElement.clientHeight - 100;
    };
  },
  created() {
    this.searchForm.DateMoreThan = this.getDay1(1);
    this.searchForm.DateLessThan = this.getDay1(-7);
    this.searchForm.DateLessThan1 = this.getDay(-8);
    this.searchForm.DateMoreThan1 = this.getDay(0);
    this.getSupplierOrder();
  },
};
</script>
<style scoped>
.hei {
  height: 1.5rem;
}
.font_btn {
  font-size: 15px !important;
}
.jz_title {
  vertical-align: middle;
}
.sou_container {
  position: absolute;
  flex-wrap: wrap;
  top: 35%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
}
.input_sou {
  width: 300px;
  height: 35px;
  font-size: 20px;
}
.font_sou {
  font-size: 20px;
}
.button_sou {
  height: 35px;
}
.font {
  font-size: 15px;
}
.button_zi {
  text-shadow: #000 1px 0 0;
  border-radius: 4px;
  border: none;
  color: azure;
}
.sett {
  width: 1300px;
  table-layout: fixed;
}
.sett-td {
  white-space: nowrap;

  overflow: hidden;

  text-overflow: ellipsis;

  -moz-text-overflow: ellipsis;
}
.autocut {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  -khtml-text-overflow: ellipsis;
  -moz-text-overflow: ellipsis;
  -webkit-text-overflow: ellipsis;
}
.autocut:hover {
  overflow: visible;
  width: 260px;
  white-space: nowrap;
  word-wrap: break-word;
  text-align: center;
}
.add_autocut {
  overflow: visible;
  width: 260px;
  white-space: nowrap;
  word-wrap: break-word;
  text-align: center;
}
.hei {
  height: 1.5rem;
}
.alert_show {
  position: absolute;
  top: 81px;
  left: 450px;
}
.yanse {
  color: red;
}
.yanse1 {
  color: green;
}
.disabled_state {
  color: red;
  font-size: 15px;
  /* border:.1px solid red; */
}
.jz_middle {
  vertical-align: middle;
}
.span_close:hover {
  color: #3190e8;
}
.input_form-control {
  /* // display: block;  */
  width: 50%;
  height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.428571429;
  color: #555555;
  vertical-align: middle;
  background-color: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color ease-in-out 0.15s,
    box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}
.input_form-control:focus {
  border-color: #66afe9;
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
}
.input_form-control:disabled {
  border: 1px solid #ddd;
  background-color: #f5f5f5;
  color: #aca899;
  opacity: 1;
}
.table_chuang {
  width: 1000px;
  height: 400px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/PutStorage.vue